/* eslint-disable @trello/disallow-filenames */

export const Categories = {
  Popular: 'popular',
  Business: 'business',
  Design: 'design',
  Education: 'education',
  Engineering: 'engineering',
  Marketing: 'marketing',
  HumanResources: 'operations-hr',
  Operations: 'operations',
  SalesCRM: 'sales-crm',
} as const;
export type Category = (typeof Categories)[keyof typeof Categories];

export type TemplatesListHash = Record<Category, string[]>;

export type LocalizedTemplatesListHash = {
  [key: string]: TemplatesListHash;
};
